import { message } from 'antd';
import axiosInstance from '../../utils/axiosInstance'; // ✅ use your configured instance

export const getAllCars = () => async dispatch => {
  dispatch({ type: 'LOADING', payload: true });
  try {
    const response = await axiosInstance.get('/api/cars/getallcars');
    dispatch({ type: 'GET_ALL_CARS', payload: response.data });
    dispatch({ type: 'LOADING', payload: false });
  } catch (error) {
    console.log(error);
    dispatch({ type: 'LOADING', payload: false });
  }
};

export const addCar = (reqObj) => async dispatch => {
  dispatch({ type: 'LOADING', payload: true });
  try {
    await axiosInstance.post('/api/cars/addcar', reqObj);
    dispatch({ type: 'LOADING', payload: false });
    message.success('New car added successfully');
    setTimeout(() => {
      window.location.href = '/home';
    }, 500);
  } catch (error) {
    console.log(error);
    dispatch({ type: 'LOADING', payload: false });
  }
};

export const updateCar = (car) => async dispatch => {
  dispatch({ type: 'LOADING', payload: true });
  try {
    await axiosInstance.put('/api/cars/editcar', car);
    dispatch({ type: 'LOADING', payload: false });
    alert('Car updated successfully');
    window.location.href = '/admin';
  } catch (error) {
    dispatch({ type: 'LOADING', payload: false });
    console.error(error);
  }
};

export const deleteCar = (car) => async dispatch => {
  dispatch({ type: 'LOADING', payload: true });
  try {
    await axiosInstance.post('/api/cars/deletecar', car);
    message.success('Car deleted successfully');
    dispatch(getAllCars()); // refresh cars
    dispatch({ type: 'LOADING', payload: false });
  } catch (error) {
    console.error(error);
    dispatch({ type: 'LOADING', payload: false });
    message.error('Failed to delete car');
  }
};
